import { getClientMchd, GetClientMchdResponse } from '../api';
import { useAuthStore } from '@/features/Auth/model/authStore';
import { useLocation } from 'react-router-dom';
import { useQuery } from '@tanstack/react-query';

const MCHD_POLL_INTERVAL_MS = 10_000;

const getShouldRefetchMchd = (data: GetClientMchdResponse | undefined): boolean => {
  if (!data?.pending_invite) return false;

  const pendingInviteExpiresAt = new Date(data.pending_invite.expires_at).getTime();

  if (Number.isNaN(pendingInviteExpiresAt) || Date.now() >= pendingInviteExpiresAt) return false;

  return true;
};

export const useProfileClientMchdApi = () => {
  const location = useLocation();
  const orgId = useAuthStore((state) => state.tokenData?.org_id ?? null);

  return useQuery({
    enabled: Boolean(orgId),
    queryFn: () => getClientMchd({ orgId: orgId as string }),
    queryKey: ['getClientMchd', location.pathname, orgId],
    refetchInterval: (query) => getShouldRefetchMchd(query.state.data) ? MCHD_POLL_INTERVAL_MS : false,
    staleTime: 300_000
  });
};